import React, { useEffect, useState } from 'react'
import Footer from '../components/footer/Footer';
import useStyles from '../styles/holiday_schedule';
import { styled } from '@mui/system'
import { Link } from 'react-router-dom';
import Popup from '../components/appbar/Popup';


const HolidayScheduleContainer: React.FC = () => {
    const classes = useStyles()

    useEffect(() => {
        const sectionEl = document.getElementById("atm-locators-hero")
        const handleScroll = () => {
            const position = 217.168 + window.scrollY * 0.65
            if(sectionEl){
                if(position >= 500){
                    sectionEl.style.backgroundPosition = `0px -500px`
                }else{
                    sectionEl.style.backgroundPosition = `0px -${position}px`
                }
            }
            
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
    const Hero = styled('section')(({ theme }) => ({
        position: 'relative',
        backgroundImage: 'url(imgs/atm_locator.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: '0px -217.168px',
        padding: '150px 0px',
        top: '-100px',
        marginBottom: '-100px',
        textShadow: 'none !important',
        borderBottom: 'none',
        backgroundColor: 'transparent',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        transition: 'all 0.17s linear !important',

        [theme.breakpoints.down('md')]: {
            padding: '100px 0px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '60px 0px',
        },
    }));
    const MainContent = styled('section')(({ theme }) => ({
        position: 'relative',
        overflow: 'hidden',
        background: '#fff',
        margin: '0',
    }));


    const [needed, setNeeded] = useState<boolean>(false)
    const [name, setName] = useState<string>('')
    const handleStarLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()
        
        setName("home-star-atm")
        setNeeded(true)
    }

  return (
    <>
        <main>
            <Hero id='atm-locators-hero'>
                <div className={classes.heroInner}>
                    <h1 className={classes.heroInnerH1}>ATM LOCATORS</h1>
                </div>
            </Hero>

            <MainContent>
                <div className={classes.mainContentInner}>
                        <div className={classes.mainContentInnerContainer}>
                            <div style={{clear: 'both', float: 'none', paddingRight: '0', position: 'relative', width: '100%'}}>
                                <div className={classes.pageTitle}>
                                    <h2 className={classes.pageTitleH2}>Never Fret About Fees</h2>
                                </div>

                                <p className={classes.paragraph} style={{marginBottom: '40px'}}>Find a free ATM with any of the ATM locators below.</p>

                                
                                <a onClick={handleStarLink} href='http://www.star.com/?go=atmLocator.start' target='_blank' className='linkImgBtn'>
                                    <img src="/imgs/star.gif" style={{border: 'none', maxWidth: '100%', verticalAlign: 'middle'}} alt="" />
                                </a>

                            </div>
                        </div>
                </div>


            </MainContent>

    


            <Footer />
        </main>
        <Popup needed={needed} setNeeded={setNeeded} name={name} setName={setName}/>
    </>
  )
}

export default HolidayScheduleContainer
